// Posts/AdvancedPostModal specific translations
export const postsTranslations = {
  en: {
    createPost: "Create New Post",
    editPost: "Edit Post", 
    showcaseLabel: "Showcase your coffee shop's offerings",
    showcasePlaceholder: "Showcase your coffee shop... New menu items, fresh pastries, specialty drinks, daily specials, or shop highlights...",
    location: "Location (optional)",
    locationPlaceholder: "e.g., Downtown Location, Main Street Branch",
    category: "Category (optional)",
    selectCategory: "Select a category",
    price: "Price (optional)",
    pricePlaceholder: "e.g., $4.50, From $3.00",
    featured: "Feature this post (show prominently)",
    productPhotos: "Product Photos",
    existing: "Existing",
    addPhoto: "Add Photo",
    addHashtag: "Add Hashtag",
    enterHashtag: "Enter hashtag (without #):",
    photosCount: "photos",
    hashtagsSupported: "Hashtags supported",
    posting: "Posting...",
    updating: "Updating...",
    post: "Post",
    featuredBadge: "Featured",
    categories: {
      coffee: "Coffee",
      pastries: "Pastries", 
      sandwiches: "Sandwiches",
      specials: "Daily Specials",
      beverages: "Other Beverages",
      desserts: "Desserts"
    }
  },
  fr: {
    createPost: "Créer une Nouvelle Publication",
    editPost: "Modifier la Publication",
    showcaseLabel: "Mettez en valeur les offres de votre café",
    showcasePlaceholder: "Mettez en valeur votre café... Nouveaux éléments du menu, pâtisseries fraîches, boissons spéciales, spéciaux quotidiens, ou points forts du café...",
    location: "Emplacement (optionnel)",
    locationPlaceholder: "ex., Emplacement du Centre-ville, Succursale Rue Principale",
    category: "Catégorie (optionnelle)",
    selectCategory: "Sélectionner une catégorie",
    price: "Prix (optionnel)",
    pricePlaceholder: "ex., 4,50 $, À partir de 3,00 $",
    featured: "Mettre en vedette cette publication (afficher de manière proéminente)",
    productPhotos: "Photos de Produits",
    existing: "Existant",
    addPhoto: "Ajouter une Photo",
    addHashtag: "Ajouter un Hashtag",
    enterHashtag: "Entrer le hashtag (sans #):",
    photosCount: "photos",
    hashtagsSupported: "Hashtags supportés",
    posting: "Publication en cours...",
    updating: "Mise à jour...",
    post: "Publier",
    featuredBadge: "En Vedette",
    categories: {
      coffee: "Café",
      pastries: "Pâtisseries",
      sandwiches: "Sandwichs", 
      specials: "Spéciaux Quotidiens",
      beverages: "Autres Boissons",
      desserts: "Desserts"
    }
  },
  es: {
    createPost: "Crear Nueva Publicación",
    editPost: "Editar Publicación",
    showcaseLabel: "Muestra las ofertas de tu café",
    showcasePlaceholder: "Muestra tu café... Nuevos elementos del menú, pasteles frescos, bebidas especiales, especiales diarios, o destacados del café...",
    location: "Ubicación (opcional)",
    locationPlaceholder: "ej., Ubicación del Centro, Sucursal Calle Principal",
    category: "Categoría (opcional)",
    selectCategory: "Seleccionar una categoría",
    price: "Precio (opcional)",
    pricePlaceholder: "ej., $4.50, Desde $3.00",
    featured: "Destacar esta publicación (mostrar prominentemente)",
    productPhotos: "Fotos de Productos",
    existing: "Existente",
    addPhoto: "Agregar Foto",
    addHashtag: "Agregar Hashtag",
    enterHashtag: "Ingrese hashtag (sin #):",
    photosCount: "fotos",
    hashtagsSupported: "Hashtags soportados",
    posting: "Publicando...",
    updating: "Actualizando...",
    post: "Publicar",
    featuredBadge: "Destacado",
    categories: {
      coffee: "Café",
      pastries: "Pasteles",
      sandwiches: "Sándwiches",
      specials: "Especiales Diarios", 
      beverages: "Otras Bebidas",
      desserts: "Postres"
    }
  },
  ar: {
    createPost: "إنشاء منشور جديد",
    editPost: "تحرير المنشور",
    showcaseLabel: "اعرض عروض مقهاك",
    showcasePlaceholder: "اعرض مقهاك... عناصر قائمة جديدة، معجنات طازجة، مشروبات خاصة، عروض يومية، أو معالم المقهى...",
    location: "الموقع (اختياري)",
    locationPlaceholder: "مثال، موقع وسط المدينة، فرع الشارع الرئيسي",
    category: "الفئة (اختيارية)",
    selectCategory: "اختر فئة",
    price: "السعر (اختياري)",
    pricePlaceholder: "مثال، 4.50 دولار، من 3.00 دولار",
    featured: "تميز هذا المنشور (إظهار بشكل بارز)",
    productPhotos: "صور المنتجات",
    existing: "موجود",
    addPhoto: "إضافة صورة",
    addHashtag: "إضافة هاشتاغ",
    enterHashtag: "أدخل الهاشتاغ (بدون #):",
    photosCount: "صور",
    hashtagsSupported: "هاشتاغ مدعوم",
    posting: "جاري النشر...",
    updating: "جاري التحديث...",
    post: "نشر",
    featuredBadge: "مميز",
    categories: {
      coffee: "قهوة",
      pastries: "معجنات",
      sandwiches: "سندويشات",
      specials: "عروض يومية",
      beverages: "مشروبات أخرى", 
      desserts: "حلويات"
    }
  }
};
